import { Field, reduxForm } from 'redux-form'
import { connect } from 'react-redux'
const renderField = ({ input, label, type, placeholder, meta: { submitFailed, error } }) => (
  <div>
    <textarea {...input} placeholder={placeholder} type='text' rows='4' cols='50' maxLength='250' />
    {submitFailed && error && <span className='error'>{error}</span>}
  </div>
)

const validate = values => {
  const errors = {}
  if (values.comment) {
    if (values.comment.trim() === '') {
      errors.comment = 'This field is required'
    }
  } else {
    errors.comment = 'This field is required'
  }
  return errors
}

let messageForm = (props) => {
  const { error, handleSubmit, data } = props

  return (
    <form onSubmit={handleSubmit} className='messageForm' name='messageForm'>
      <div className='form-content'>
        <div className='left-content'>
          <div>
            <img alt='Account profile default' className='avatar' src='https://www.mokapos.com/assets/account-profile-default-16e73004f9284381ca77f13a3457f43d.jpg' />
          </div>
          <span className='striped text-center'>{data && data.customer_name}</span>
        </div>
        <div className='right-content'>
          <Field
            component={renderField}
            name='comment'
            autoCorrect='off'
            autoCapitalize='off'
            placeholder='Write a reply...'
          />
          {error && <strong>{error}</strong>}
        </div>
      </div>
      <div className='reply-btn-wrapper pull-right'>
        <button className='btn btn-primary' id='submit-feedback' type='submit'>Submit</button>
      </div>
    </form>
  )
}
messageForm = reduxForm({
  form: 'messageForm',
  validate
})(messageForm)

export default connect()(messageForm)



// WEBPACK FOOTER //
// ./app/pages/FeedbackReplyForm/messageForm.js